module.exports = InternalShared('InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet');